import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import leaf from '../../assets/images/leaf.svg';
import Pagination from '../../components/Pagination';
import { formatDate } from '../../utils/formatDate';
import Button from '../../components/Button';
import {
  NoticesData,
  NoticesListData,
} from '../../api/service/NoticeInterfaces';
import AdminNoticeService from '../../api/service/admin/AdminNoticeService';

const NoticeTabWrapper = styled.div``;

const NoticeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  img {
    width: 20px;
  }
`;

const TableContainer = styled.div`
  overflow-x: auto;
  min-height: 481px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const TableContent = styled.div`
  white-space: pre-wrap; /* 줄바꿈과 공백 유지 */
  word-wrap: break-word; /* 단어 단위로 줄바꿈 */
  word-break: break-word; /* 긴 단어도 강제 줄바꿈 */

  padding: 10px;
  background-color: #ebf0ee;
  height: 426px;
`;

const TableBox = styled.div`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const TableAdd = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: white;

  tr {
    border-bottom: 1px solid #ddd;
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    width: 150px;
    background-color: #85c1a9;
    color: white;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    tr {
      border-bottom: 1px solid #ddd;
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      width: 70px;
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }
  }
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: white;

  tr {
    border-bottom: 1px solid #ddd;
  }

  tr:nth-child(12) {
    border-bottom: none; /* 마지막 행의 border 제거 */
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    background-color: #85c1a9;
    color: white;
    font-weight: 500;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }

  th:last-child {
    border-top-right-radius: 10px;
  }

  /* 제목 열을 가장 넓게 설정 */
  th:nth-child(2),
  td:nth-child(2) {
    width: 50%; /* 제목 열의 폭을 설정 */
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    tr {
      border-bottom: 1px solid #ddd;
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }

    /* 제목 열 폭 조정 */
    th:nth-child(2),
    td:nth-child(2) {
      width: 40%; /* 모바일 환경에서의 폭 */
    }
  }
`;

const FormContainer = styled.div``;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 450px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  resize: none;
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
const ButtonContainer2 = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

function AdminTab1() {
  const [notice, setNotice] = useState<NoticesListData[]>([]);
  const [selectedNotice, setSelectedNotice] = useState<NoticesData | null>(
    null
  );
  const [selectedIndex, setSelectedIndex] = useState<number>(0); //
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [showForm, setShowForm] = useState<boolean>(false); // 폼 표시 여부 상태
  const [isEditing, setIsEditing] = useState<boolean>(false); // 수정 모드 상태
  const [formData, setFormData] = useState({ title: '', content: '' }); // 폼 데이터 상태

  const handleRowClick = async (index: number, questionId: string) => {
    try {
      const response =
        await AdminNoticeService.getAdminNoticeDetail(questionId);
      setSelectedNotice(response.data);
      setSelectedIndex(index);

      // URL 업데이트 (페이지 이동 없이)
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('questionId', questionId);
      window.history.pushState({}, '', currentUrl);
    } catch (error) {
      console.error('공지사항 상세 조회 실패:', error);
    }
  };

  const handleButtonClick = async () => {
    setSelectedNotice(null); // 선택된 공지사항 데이터 저장

    // URL 초기화 (페이지 이동 없이)
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('questionId');
    window.history.pushState({}, '', currentUrl);
  };

  const handleAddButtonClick = () => {
    setShowForm(true);
    setIsEditing(false); // 추가 모드
    setFormData({ title: '', content: '' }); // 폼 데이터 초기화
  };

  const handleEditButtonClick = () => {
    if (selectedNotice) {
      setShowForm(true);
      setIsEditing(true); // 수정 모드
      setFormData({
        title: selectedNotice.title,
        content: selectedNotice.content,
      });
    }
  };

  const handleFormSubmit = async () => {
    try {
      if (isEditing) {
        // 수정 모드
        await AdminNoticeService.updateAdminNotice(
          selectedNotice?.noticeId || '',
          formData
        );
        alert('공지사항이 성공적으로 수정되었습니다.');
      } else {
        // 추가 모드
        await AdminNoticeService.createAdminNotice(formData);
        alert('공지사항이 성공적으로 제출되었습니다.');
      }
      setShowForm(false);
      setFormData({ title: '', content: '' }); // 폼 데이터 초기화
      setSelectedNotice(null); // 선택된 공지사항 데이터 저장
      fetchNotices(currentPage); // 제출 후 목록 새로고침
    } catch (error) {
      console.error('공지사항 제출 실패:', error);
      alert(error);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchNotices(page);
  };

  useEffect(() => {
    fetchNotices(0);

    // URL에서 questionId 가져오기
    const urlParams = new URLSearchParams(window.location.search);
    const questionId = urlParams.get('questionId');

    if (questionId) {
      handleRowClick(0, questionId);
    }
  }, []);

  const fetchNotices = async (currentPage: number) => {
    try {
      const response = await AdminNoticeService.getAdminNoticesList(
        currentPage,
        12
      );
      setNotice(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  const handleDeleteButtonClick = async () => {
    if (!selectedNotice) return;

    const confirmDelete = window.confirm('정말로 삭제하시겠습니까?');
    if (!confirmDelete) return;

    try {
      await AdminNoticeService.deleteAdminNotice(selectedNotice.noticeId);
      alert('공지사항이 성공적으로 삭제되었습니다.');
      setSelectedNotice(null); // 선택된 데이터 초기화
      fetchNotices(currentPage); // 목록 새로고침
    } catch (error) {
      console.error('공지사항 삭제 실패:', error);
      alert(error);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <NoticeTabWrapper>
      <NoticeHeader>
        <img src={leaf} alt="leaf" />
        <h1>공지사항</h1>
      </NoticeHeader>
      {showForm ? (
        <FormContainer>
          <TableAdd>
            <tbody>
              <tr>
                <th>제목</th>
                <td>
                  <Input
                    type="text"
                    name="title"
                    placeholder="제목을 입력해 주세요"
                    value={formData.title}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                  />
                </td>
              </tr>
              <tr>
                <th>공지사항</th>
                <td>
                  <TextArea
                    name="content"
                    placeholder="공지사항을 입력해주세요"
                    value={formData.content}
                    onChange={handleChange}
                  />
                </td>
              </tr>
            </tbody>
          </TableAdd>
          <ButtonGroup>
            <Button save={true} onClick={handleFormSubmit}>
              {isEditing ? '수정하기' : '등록하기'}
            </Button>
            <Button
              onClick={() => {
                setShowForm(false);
                fetchNotices(currentPage); // 제출 후 목록 새로고침
                setFormData({ title: '', content: '' }); // formData 초기화
              }}
            >
              취소
            </Button>
          </ButtonGroup>
        </FormContainer>
      ) : selectedNotice ? (
        <>
          <TableContainer>
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={selectedNotice.noticeId}>
                    <td>{selectedIndex + 1}</td>
                    <td>
                      {selectedNotice.title.length > 30
                        ? selectedNotice.title.substring(0, 30) + '...'
                        : selectedNotice.title}
                    </td>
                    <td>관리자</td>
                    <td>{formatDate(selectedNotice.regDate)}</td>
                  </tr>
                </tbody>
              </Table>
            </TableBox>
            <TableContent>{selectedNotice.content}</TableContent>
          </TableContainer>
          <ButtonContainer>
            <div>
              <Button
                save={true}
                onClick={handleEditButtonClick}
                style={{ marginRight: 10 }}
              >
                수정하기
              </Button>

              <Button onClick={handleDeleteButtonClick}>삭제</Button>
            </div>
            <Button save={true} onClick={() => handleButtonClick()}>
              목록
            </Button>
          </ButtonContainer>
        </>
      ) : (
        <>
          <TableContainer>
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  {notice.length === 0 && (
                    <tr>
                      <td colSpan={4}>공지사항이 없습니다.</td>
                    </tr>
                  )}
                  {notice.map((item, index) => (
                    <tr
                      key={item.noticeId}
                      onClick={() => handleRowClick(index, item.noticeId)}
                    >
                      <td>{index + 1}</td>
                      <td>
                        {item.title.length > 30
                          ? item.title.substring(0, 30) + '...'
                          : item.title}
                      </td>
                      <td>관리자</td>
                      <td>{formatDate(item.regDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableBox>
          </TableContainer>
          <ButtonContainer2>
            <Button save={true} onClick={handleAddButtonClick}>
              공지사항 등록
            </Button>
          </ButtonContainer2>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </NoticeTabWrapper>
  );
}

export default AdminTab1;
